import TableComponent from "components/Table"
import { URL_PATHS } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row } from "reactstrap"
import { getRecentExperiences } from "store/actions"
import recentExperiencesListColumns from "./recentExperiencesListColumns"

const RecentExperiences = ({
  recentExperiences,
  handleRemoveWidget,
  getRecentExperiences,
  history,
}) => {
  useEffect(() => {
    getRecentExperiences({})
  }, [])

  const viewReportHandler = () => {}

  return (
    <Col xs={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h5>Experiences</h5>
            </Col>
            <Col xs="auto">
              <i
                className="bx bx-x font-size-22"
                style={{ cursor: "pointer" }}
                onClick={handleRemoveWidget}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <TableComponent
                data={recentExperiences?.slice(0, 10)}
                columns={recentExperiencesListColumns(history)}
                loadingData={!recentExperiences}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const mapStateToProps = state => ({
  recentExperiences: state.Analytics.recentExperiences,
})

const mapDispatchToProps = dispatch => ({
  getRecentExperiences: values => dispatch(getRecentExperiences(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RecentExperiences))
